<template>
    <vertical-form-table v-model="form" v-bind="{ items }" @input="emit">
        <template #해시태그>
            <v-autocomplete v-model="form.hashTags" :items="hashTags" :menuProps="{ attach: `.form-baseinfo-hashTags-${className}` }" attach :class="`form-baseinfo-hashTags-${className}`" multiple small-chips outlined @input="emit" @change="emit">
                <template #selection="{ item }">
                    <v-chip outlined small label color="grey-d" class="grey-9--text ma-2 ma-lg-4">{{ item }}</v-chip>
                </template>
            </v-autocomplete>
        </template>
        <template #접수기간>
            <form-baseinfo-application v-model="form.application" @input="emit" />
        </template>
    </vertical-form-table>
</template>

<script>
import { initRecruitment } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import FormBaseinfoApplication from "./form-baseinfo-application.vue";

export default {
    components: {
        VerticalFormTable,
        FormBaseinfoApplication,
    },
    props: {
        value: { type: Object, default: initRecruitment },
        hashTags: { type: Array, default: () => [] },
    },
    data: () => ({
        form: initRecruitment(),

        className: Math.random().toString().slice(2),
    }),
    computed: {
        items() {
            return [
                {
                    key: "subject",
                    term: "제목",
                    type: "text",
                    required: true,
                },
                {
                    term: "해시태그",
                },
                // {
                //     key: "summary",
                //     term: "요약",
                //     type: "textarea",
                //     rows: "1",
                //     autoGrow: true,
                // },
                {
                    key: "content",
                    term: "상세",
                    type: "editor",
                    required: true,
                },
                {
                    key: "attachments",
                    term: "첨부파일",
                    type: "file-chips",
                },
                {
                    term: "접수기간",
                    required: true,
                },
            ].map((item) => ({ ...item, outlined: true }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitment(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-select--chips {
        .v-input__slot,
        .v-select__selections {
            height: auto;
            min-height: 40px !important;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    ::v-deep {
        .v-select--chips {
            .v-input__slot,
            .v-select__selections {
                min-height: 48px !important;
            }
        }
    }
}
@media (min-width: 1200px) {
}
</style>
